import apiClient from "../config/apiClient";

// export const sendRadiologyRequest = async (data) => {
//     const user = window.localStorage.getItem("token");
//     const token = user;
//     return await apiClient.post(`/public/portal?url=requests/save-request`,
//       data,
//        {
//         headers: {
//         Authorization: "Bearer " + token,
//       },
//     });
// };


export const sendRadiologyRequest = async (data) => {
  const user = window.localStorage.getItem("token");
  const token = user;
  return await apiClient.post(`/public/portal?url=requests/save-request`, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};
